import type { MultiplePartnerValue } from "../dynamicForm/types";

export const SUPPLIER_QUESTION_ID = "8957cffe-4a0f-407b-8286-c23cb4bb7fc0";
export const AGREEMENTS_QUESTION_ID = "ee81c5ce-99b4-4a48-b350-128e4c1dacbe";

export const getPartnerIds = (suppliers: MultiplePartnerValue | null | undefined) =>
  (suppliers ?? []).filter(supplier => supplier.type === "partner").map(supplier => supplier.id);
